import { useContext } from 'react';

import { useStoreWithEqualityFn } from 'zustand/traditional';

import { FormContext } from '../contexts';
import type { FormStore } from '../stores';

export function useFormStore<T>(selector: (state: FormStore) => T, equalityFn?: (left: T, right: T) => boolean): T {
	const store = useContext(FormContext);
	if (!store) {
		throw new Error('Missing FormContext.Provider in the tree');
	}
	return useStoreWithEqualityFn(store, selector, equalityFn);
}
